import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {Auction, WatchingAuction} from "domain-models"
import Form from "mixins/form"
import {FormType} from "mixins/FormTypes"
import {Http} from "mixins/http"
import React from "react"
import {setAuctions} from "redux/actions"
import {store} from 'store'
import {connect} from "react-redux"
import {GlobalState} from "../../../state"
import {translate} from '../../../filters'

type WatchButtonProps = {
  auction: Auction
  hidden?: boolean
  styleName?: string
  auctions: Array<Auction>
}

type WatchButtonState = {
  form: FormType
}

class WatchButton extends React.Component<WatchButtonProps, WatchButtonState> {
  constructor(props: WatchButtonProps) {
    super(props)
    this.state = {
      form: new Form({})
    }
  }

  watch = async (event: React.MouseEvent) => {
    event.stopPropagation()
    event.preventDefault()
    this.props.auction.watched_by_user = await Http.post<WatchingAuction>('auctions/' + this.props.auction.Id + '/watch', {
      state: this,
      form: this.state.form
    })
    store.dispatch(setAuctions(this.props.auctions))
  }

  unwatch = async (event: React.MouseEvent) => {
    event.stopPropagation()
    event.preventDefault()
    if (!this.props.auction.watched_by_user) {
      return
    }
    await Http.delete('auctions/' + this.props.auction.Id + '/watch/' + this.props.auction.watched_by_user.id, {
      state: this,
      form: this.state.form
    })
    this.props.auction.watched_by_user = null
    store.dispatch(setAuctions(this.props.auctions))
  }

  render() {
    const disabled = this.props.auction.status === 'ended' || this.props.hidden
    const watched = !!(this.props.auction.watched_by_user)
    return (
      <button title={watched ? translate("Nicht mehr beobachten") : translate("Auktion beobachten")} className={'rounded px-3 py-1 font-semibold whitespace-no-wrap shadow text-xs ' + (this.state.form.busy || disabled ? ' cursor-not-allowed opacity-75 ' : '') + (watched ? ' bg-yellow-100 text-yellow-500 hover:bg-yellow-300 ' : ' bg-gray-100 text-gray-400 hover:bg-gray-200 ') + (this.props.styleName || '') + (disabled ? ' hidden ' : '')} disabled={this.state.form.busy || disabled} onClick={watched ? this.unwatch : this.watch}>
        <Icon icon={this.state.form.busy ? 'spinner' : "star"} spin={this.state.form.busy}/>
      </button>
    )
  }
}

export default connect((state: GlobalState) => ({
  auctions: state.auctions.auctions
}))(WatchButton)
